import script from "./ConnecteraLogo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConnecteraLogo.vue?vue&type=script&setup=true&lang=ts"

import "./ConnecteraLogo.vue?vue&type=style&index=0&id=e111599a&scoped=true&lang=css"

import exportComponent from "/opt/sources/madarion/mdnw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e111599a"]])

export default __exports__